import {fetch} from "../../../utils/dataAccess";

export function error(error) {
    return {type: "ORDER_LINE_ITEM_ACTIVITY_LIST_ERROR", error};
}

export function loading(loading) {
    return {type: "ORDER_LINE_ITEM_ACTIVITY_LIST_LOADING", loading};
}

export function success(retrieved) {
    return {type: "ORDER_LINE_ITEM_ACTIVITY_LIST_SUCCESS", retrieved};
}

let listRequest = null;
export function list(params = `order[createdAt]=asc`) {
    return dispatch => {
        if (!!listRequest) {
            return;
        }

        dispatch(loading(true));
        listRequest = fetch("/line_item_activities_list?" + params);
        listRequest.then(response => {
            response.json().then(retrieved => {
                dispatch(loading(false));
                dispatch(success(retrieved));
            }).catch(() => {
                dispatch(loading(false));
            });
        }).catch(error => {
            // cancelled
        }).finally(() => listRequest = null);
    }
}

export function reset() {
    return dispatch => {
        dispatch({type: "ORDER_LINE_ITEM_ACTIVITY_LIST_RESET"});
    };
}
